export default "__VITE_ASSET__CPSOI9Ug__"